module.exports = __webpack_public_path__ + "static/media/95moratelindo.03f492e3.png";